import ImageTips from './ImageTips.json';

export type PhotoInput = {
  category?: string;
  condition?: string;
  label: string;
  name: string;
  skip?: boolean;
}

export type PhotoSectionsProps = {
  [key: string]: {
    helper: string;
    inputs: PhotoInput[];
    strap: string;
    title: string;
  };
}

const photoSections: PhotoSectionsProps = {
  exterior: {
    helper: ImageTips.photos.exterior.content,
    inputs: [
      {
        category: 'exterior',
        label: 'Front driver side',
        name: 'exterior_front_driver',
      },
      {
        category: 'exterior',
        label: 'Rear driver side',
        name: 'exterior_rear_driver',
      },
      {
        category: 'exterior',
        label: 'Front passenger side',
        name: 'exterior_front_passenger',
      },
      {
        category: 'exterior',
        label: 'Rear passenger side',
        name: 'exterior_rear_passenger',
      },
    ],
    strap: 'Ensure the whole of the car is visible in each photo.',
    title: 'Exterior',
  },
  interior: {
    helper: ImageTips.photos.interior.content,
    inputs: [
      {
        category: 'interior',
        label: 'Front seats',
        name: 'interior_front_seats',
      },
      {
        category: 'interior',
        label: 'Rear seats',
        name: 'interior_rear_seats',
        skip: true,
      },
      {
        category: 'interior',
        label: 'Dashboard',
        name: 'interior_dashboard',
      },
      {
        category: 'interior',
        label: 'Boot',
        name: 'interior_boot',
        skip: true,
      },
      {
        category: 'interior',
        label: 'Instrument cluster',
        name: 'instrument_cluster',
      },
    ],
    strap: 'Take zoomed-out photos showing as much of the interior as possible.',
    title: 'Interior',
  },
  treads: {
    helper: ImageTips.photos.treads.content,
    inputs: [
      {
        category: 'treads',
        label: 'Front driver side',
        name: 'tyre_tread_front_driver',
      },
      {
        category: 'treads',
        label: 'Rear driver side',
        name: 'tyre_tread_rear_driver',
      },
      {
        category: 'treads',
        label: 'Front passenger side',
        name: 'tyre_tread_front_passenger',
      },
      {
        category: 'treads',
        label: 'Rear passenger side',
        name: 'tyre_tread_rear_passenger',
      },
    ],
    strap: 'Take close-up photos from the ground showing the tread of each tyre.',
    title: 'Tyre treads',
  },
  wheels: {
    helper: ImageTips.photos.wheels.content,
    inputs: [
      {
        category: 'wheels',
        label: 'Front driver side',
        name: 'wheels_front_driver',
      },
      {
        category: 'wheels',
        label: 'Rear driver side',
        name: 'wheels_rear_driver',
      },
      {
        category: 'wheels',
        label: 'Front passenger side',
        name: 'wheels_front_passenger',
      },
      {
        category: 'wheels',
        label: 'Rear passenger side',
        name: 'wheels_rear_passenger',
      },
    ],
    strap: 'Take side-on photos showing the whole wheel and tyre.',
    title: 'Wheels',
  },
};

const conditionSection: PhotoSectionsProps = {
  damage: {
    helper: ImageTips.photos.condition.content,
    inputs: [
      {
        condition: 'condition.scratches',
        label: 'Scratches and scuffs',
        name: 'damage_scratches',
      },
      {
        condition: 'condition.dents',
        label: 'Dents',
        name: 'damage_dents',
      },
      {
        condition: 'condition.wheels',
        label: 'Wheel damage',
        name: 'damage_wheels',
      },
      {
        condition: 'condition.tyres',
        label: 'Tyre damage',
        name: 'damage_tyres',
      },
      {
        condition: 'condition.paintwork',
        label: 'Other paintwork problems',
        name: 'damage_paintwork',
      },
      {
        condition: 'condition.windscreen',
        label: 'Windscreen damage',
        name: 'damage_windscreen',
      },
      {
        condition: 'condition.trim',
        label: 'Broken or missing fittings',
        name: 'damage_missing_trims',
      },
      {
        condition: 'condition.dashboard',
        label: 'Warning lights',
        name: 'damage_warning_lights',
      },
      {
        label: 'Mechanical or electrical issues',
        name: 'damage_electrical_mechanical',
      },
      {
        label: 'Additional info',
        name: 'damage_other',
      },
    ],
    strap: 'Take close-up photos from the ground showing the tread of each tyre.',
    title: 'Condition photos',
  },
};

const serviceHistorySection = {
  service_history: {
    helper: ImageTips.photos.service.content,
    inputs: [
      {
        label: '',
        name: 'docs_service_history',
      },
    ],
    strap: 'Take clear photos of your service records.',
    title: 'Service record photos',
  },
};

export { photoSections, conditionSection, serviceHistorySection };
